import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFleetVehicles } from "@/hooks/use-fleet-entities";
import { Search } from "lucide-react";

interface TireFiltersProps {
  companyId: string;
  filters: any;
  onFilterChange: (key: string, value: any) => void;
}

export function TireFilters({ companyId, filters, onFilterChange }: TireFiltersProps) {
  const { data: vehicles = [] } = useFleetVehicles(companyId);

  return (
    <div className="flex flex-wrap gap-4">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Buscar por marca, modelo ou série..."
          value={filters.search || ''}
          onChange={(e) => onFilterChange('search', e.target.value)}
          className="pl-10"
        />
      </div>

      <Select 
        value={filters.status || 'all'} 
        onValueChange={(v) => onFilterChange('status', v)}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos</SelectItem>
          <SelectItem value="installed">Instalados</SelectItem>
          <SelectItem value="in_stock">Em Estoque</SelectItem>
          <SelectItem value="in_repair">Em Reparo</SelectItem>
          <SelectItem value="discarded">Descartados</SelectItem>
        </SelectContent>
      </Select>

      <Select 
        value={filters.vehicleId || 'all'} 
        onValueChange={(v) => onFilterChange('vehicleId', v === 'all' ? undefined : v)}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Veículo" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos os Veículos</SelectItem>
          {vehicles.map((vehicle) => (
            <SelectItem key={vehicle.id} value={vehicle.id}>
              {vehicle.plate} - {vehicle.make}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
